import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import {
  Card,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class FranchiseEnquiry extends Component {
  state = {
    enquiries: [],
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    per_page: 20,
    page_no: 1,
    loading: false,

    notification: false,
    notiColor: "success",
    message: "",

    // reply modal
    replyModalOpen: false,
    activeEnquiry: null,
    emailSubject: "",
    emailMessage: "",
    sendingEmail: false,
  };

  componentDidMount() {
    this.fetchEnquiries(1, this.state.per_page);
  }

  /* =========================
     FETCH ENQUIRIES
  ========================= */
  fetchEnquiries = (page = 1, limit = 20) => {
    if (init() !== "success") return window.location.assign("/signin");

    this.setState({ loading: true });

    axios
      .get(`${Constants.getUrls.careerEnquiry}?page=${page}&limit=${limit}`)
      .then((res) => {
        const data = res.data?.data.docs || {};
        const meta = res.data?.meta || {};

        this.setState({
          enquiries: data || [],
          pagination: {
            page: meta.page || page,
            totalPages: meta.totalPages || 1,
            hasNextPage: meta.hasNextPage || false,
            hasPrevPage: meta.hasPrevPage || false,
            nextPage: meta.nextPage || null,
            prevPage: meta.prevPage || null,
            totalDocs: meta.totalDocs || 0,
            limit: meta.limit || limit,
          },
          page_no: meta.page || page,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to load enquiries",
        });
      });
  };

  handlePageChange = (page) => {
    this.fetchEnquiries(page, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.setState({ per_page: limit }, () => {
      this.fetchEnquiries(1, limit);
    });
  };

  /* =========================
     DELETE (SOFT)
  ========================= */
  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this enquiry?")) return;

    axios
      .delete(`${Constants.deleteUrls.deleteCareerEnquiry}${id}`)
      .then((res) => {
        this.setState({
          notification: true,
          notiColor: "success",
          message: res.data?.message || "Enquiry deleted",
        });
        this.fetchEnquiries(this.state.page_no, this.state.per_page);
      })
      .catch(() => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: "Failed to delete enquiry",
        });
      });
  };

  /* =========================
     REPLY MODAL
  ========================= */
  openReplyModal = (enquiry) => {
    this.setState({
      replyModalOpen: true,
      activeEnquiry: enquiry,
      emailSubject: "Response to your enquiry",
      emailMessage: `Hi ${enquiry.name},\n\nThank you for contacting us.\n\nRegards,`,
    });
  };

  closeReplyModal = () => {
    this.setState({
      replyModalOpen: false,
      activeEnquiry: null,
      emailSubject: "",
      emailMessage: "",
      sendingEmail: false,
    });
  };

  sendEmailToEnquiry = async () => {
    const { activeEnquiry, emailSubject, emailMessage } = this.state;

    if (!emailSubject || !emailMessage) {
      return this.setState({
        notification: true,
        notiColor: "warning",
        message: "Subject and message are required",
      });
    }

    this.setState({ sendingEmail: true });

    try {
      await axios.post(
        `${Constants.postUrls.sendMailCareerEnquiry}${activeEnquiry._id}`,
        {
          subject: emailSubject,
          message: emailMessage,
        }
      );

      this.setState({
        notification: true,
        notiColor: "success",
        message: "Email sent successfully",
      });

      this.closeReplyModal();
      this.fetchEnquiries(this.state.page_no, this.state.per_page);
    } catch {
      this.setState({
        notification: true,
        notiColor: "warning",
        message: "Failed to send email",
      });
    } finally {
      this.setState({ sendingEmail: false });
    }
  };

  /* =========================
     GMAIL CLICK
  ========================= */
  openGmailCompose = (enquiry) => {
    const subject = encodeURIComponent("Response to your enquiry");
    const body = encodeURIComponent(
      `Hi ${enquiry.name},\n\nWe received your enquiry.\n\nMessage:\n${enquiry.message}\n\nRegards`
    );
    window.open(
      `https://mail.google.com/mail/?view=cm&to=${enquiry.email}&su=${subject}&body=${body}`,
      "_blank"
    );
  };

  /* =========================
     RENDER
  ========================= */
  render() {
    const { enquiries, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Franchise Enquiries
              </MDTypography>
            </MDBox>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">Loading...</Grid>
              ) : enquiries.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "Sr", accessor: "serial" },
                      { Header: "Name", accessor: "name" },
                      { Header: "Email", accessor: "email" },
                      { Header: "Phone", accessor: "phone" },
                      { Header: "Location", accessor: "location" },
                      { Header: "Message", accessor: "message" },
                      { Header: "Action", accessor: "action" },
                    ],
                    rows: enquiries.map((item, index) => {
                      const serial =
                        (pagination.page - 1) * pagination.limit + index + 1;

                      return {
                        serial,
                        name: item.name,
                        email: (
                          <span
                            style={{ color: "#1a73e8", cursor: "pointer" }}
                            onClick={() => this.openGmailCompose(item)}
                          >
                            {item.email}
                          </span>
                        ),
                        phone: item.phone,
                        location: item.location,
                        message:
                          item.message?.length > 80
                            ? item.message.slice(0, 80) + "..."
                            : item.message,
                        action: (
                          <div style={{ display: "flex", gap: 8 }}>
                            {/* <MDButton
                              size="small"
                              variant="outlined"
                              onClick={() => this.openReplyModal(item)}
                            >
                              Reply
                            </MDButton> */}
                            <MDButton
                              size="small"
                              color="error"
                              variant="outlined"
                              onClick={() => this.handleDelete(item._id)}
                            >
                              Delete
                            </MDButton>
                          </div>
                        ),
                      };
                    }),
                  }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <MDBox p={2}>No enquiries found</MDBox>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Franchise Enquiries"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>

        {/* Reply Modal */}
        <Dialog open={this.state.replyModalOpen} onClose={this.closeReplyModal}>
          <DialogTitle>Reply to Enquiry</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Subject"
              value={this.state.emailSubject}
              onChange={(e) =>
                this.setState({ emailSubject: e.target.value })
              }
              margin="normal"
            />
            <TextField
              fullWidth
              multiline
              minRows={5}
              label="Message"
              value={this.state.emailMessage}
              onChange={(e) =>
                this.setState({ emailMessage: e.target.value })
              }
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <MDButton onClick={this.closeReplyModal}>Cancel</MDButton>
            <MDButton
              color="info"
              onClick={this.sendEmailToEnquiry}
              disabled={this.state.sendingEmail}
            >
              {this.state.sendingEmail ? "Sending..." : "Send"}
            </MDButton>
          </DialogActions>
        </Dialog>
      </DashboardLayout>
    );
  }
}
